import React from 'react';
import { motion } from 'framer-motion';
import { ScrollText, Sparkles, Bug, Zap } from 'lucide-react';
import { Badge } from '../components/Badge';
export function Changelog() {
  const releases = [{
    version: 'v2.4.0',
    date: 'May 12, 2026',
    tag: 'New',
    tagColor: 'bg-blue-50 text-blue-700',
    icon: Sparkles,
    title: 'AI Insights for Inventory',
    items: ['Predictive low-stock alerts powered by ML forecasting', 'Auto-suggest reorder quantities based on velocity', 'New AI insights widget on the Overview dashboard']
  }, {
    version: 'v2.3.2',
    date: 'April 28, 2026',
    tag: 'Improved',
    tagColor: 'bg-green-50 text-green-700',
    icon: Zap,
    title: 'Faster Reports & Dashboards',
    items: ['3x faster dashboard loading on large datasets', 'Improved CSV exports with chunked downloads', 'New keyboard shortcuts for power users']
  }, {
    version: 'v2.3.1',
    date: 'April 14, 2026',
    tag: 'Fixed',
    tagColor: 'bg-amber-50 text-amber-700',
    icon: Bug,
    title: 'Bug Fixes & Polish',
    items: ['Fixed timezone issue in scheduled reports', 'Resolved CRM contact merge edge case', 'Improved mobile order list rendering']
  }];
  return <div className="w-full" data-id="element-290">
      <section className="relative pt-20 pb-16 overflow-hidden bg-gradient-to-b from-white via-slate-50 to-indigo-50/40" data-id="element-291">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-292">
          <Badge icon={<ScrollText className="w-3.5 h-3.5" data-id="element-294" />} text="CHANGELOG" data-id="element-293" />
          <h1 className="text-5xl md:text-6xl font-black leading-[1.05] tracking-tight mb-6 text-[#0B1020]" data-id="element-295">
            What's <span className="text-brand-blue" data-id="element-296">New</span>
          </h1>
          <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-297">
            Follow along as we ship new features, improvements, and fixes to
            Akios BOS.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white" data-id="element-298">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8" data-id="element-299">
          {releases.map((release, i) => <motion.article key={release.version} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm" data-id="element-300">
              <div className="flex items-start justify-between flex-wrap gap-3 mb-4" data-id="element-301">
                <div className="flex items-center gap-3" data-id="element-302">
                  <div className="w-10 h-10 rounded-xl bg-blue-50 text-brand-blue flex items-center justify-center" data-id="element-303">
                    <release.icon className="w-5 h-5" data-id="element-304" />
                  </div>
                  <div data-id="element-305">
                    <div className="font-black text-slate-900" data-id="element-306">
                      {release.version}
                    </div>
                    <div className="text-sm text-slate-500" data-id="element-307">{release.date}</div>
                  </div>
                </div>
                <span className={`text-xs font-bold px-3 py-1 rounded-full ${release.tagColor}`} data-id="element-308">
                  {release.tag}
                </span>
              </div>
              <h2 className="text-2xl font-bold mb-4" data-id="element-309">{release.title}</h2>
              <ul className="space-y-2" data-id="element-310">
                {release.items.map(item => <li key={item} className="flex items-start gap-3 text-slate-600" data-id="element-311">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-blue mt-2 shrink-0" data-id="element-312" />
                    <span data-id="element-313">{item}</span>
                  </li>)}
              </ul>
            </motion.article>)}
        </div>
      </section>
    </div>;
}